module.exports = __webpack_public_path__ + "static/media/flxw-logo-01.48b63e6f.png";